<template>
    <div style="position: relative">
        <div class="v-flex" style="position: absolute; right: 4px; top: 6px; z-index: 10">
            <div class="error--text">({{ errors }} Fehler)</div>
            <div class="warning--text ml-2">({{ warnings }} Warnungen)</div>
        </div>
        <v-tabs
            v-model      = "tabs"
            class        = "mt-3 folder-tabs ml-0 mr-0 pr-0"
            active-class = "folder-tab-active primary"
            height       = "32"
            light
        >
            <v-tab
                class = "folder-tab"
                :key  = "1"
            >
                Eingabedatei
            </v-tab>
        </v-tabs>

        <v-tabs-items
            v-model = "tabs"
            class   = "w-100"
            style   = "height: calc(100% - 40px); margin-top: -2px!important;"
        >
            <v-tab-item
                :key  = "1"
                style = " height: calc(100% + 20px)"
            >
                <p-import-content
                    id             = "import-in-id"
                    :rows          = "displayRows"
                    :columns       = "columns"
                    :size          = "size"
                    :show-units    = "false"
                    :filter        = "filter"
                    :scroll-width  = "scrollWidth"
                    :right-padding = "70"
                    :target-format = "false"
                />
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>

import PImportContent from "@/modules/msd/importer/components/private/PImportContent.vue";

export default {
    name: "PImportInput",

    components: {
        PImportContent,
    },

    props: {
        columns: {

        },

        rows: {

        },

        size: {

        },

        filter: {

        }
    },

    data: () => ({
        headers: [],
        displayRows: null,
        errors: null,
        warnings: null,
        tabs: 1,
        scrollWidth: 6000,
    }),

    mounted() {
        this.initialize();
    },

    watch: {
        columns () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            if (!this.rows) {
                return;
            }

            this.scrollWidth = 0;
            this.columns.forEach(column => {
                this.scrollWidth += column.width;
            });

            this.displayRows = [];
            this.errors = 0;
            this.warnings = 0;
            this.rows.forEach(row => {
                const copyRow = {
                    values: [],
                }

                row.columns.forEach(column => {
                    copyRow.values.push ({
                        value: column.value.value,
                        error: column.value.error,
                        warning: column.value.warning,
                        width: column.width
                    });

                    if (column.value.error) {
                        this.errors ++;
                    }

                    if (column.value.warning) {
                        this.warnings ++;
                    }

                });

                this.displayRows.push (copyRow);
            });
        },
    }
}
</script>

<style scoped>

</style>